module.exports = __webpack_public_path__ + "static/ceramics-recent-works-thumbnail-22d1827ff6e795ff7a0521f17b6457c6.jpg";